import { useUser } from "@clerk/nextjs";
import va from "@vercel/analytics";
import { useCallback } from "react";

export function useTrack() {
  const { user } = useUser();

  return useCallback(
    (event: string, properties?: Record<string, string | number | boolean>) => {
      va.track(event, {
        ...properties,
        ...(user && {
          userId: user.id,
          userEmail: user.primaryEmailAddress?.emailAddress ?? "unknown",
        }),
      });
    },
    [user],
  );
}
